import React, { useState } from "react";
import { postRequest } from "../../utils/httpRequest";
import { t } from "../../utils/i18n";

type AddFundsCardProps = {
  transakUrl: string;
  helpUrl?: string;
};

const CreateWidget: React.FC<AddFundsCardProps> = ({}) => {
  const [submitting, setIsSubmitting] = useState(false);

  const onSubmit = (e: React.FormEvent) => {
    setIsSubmitting(true);

    postRequest("/api/v1/payment_methods/transak", {})
      .then((response) => {
        window.open(response.widget_url, "_blank", "noopener,noreferrer");
        setIsSubmitting(false);
      })
      .catch((error) => {
        setIsSubmitting(false);
        console.log(error);
      });
  };

  return (
    <div className="add-funds-card bank">
      <div className="add-funds-card-content">
        <div className="top">
          <i
            className="fa fa-credit-card"
            aria-hidden="true"
            style={{ color: "black" }}
          />
          <span className="badge badge-dark badge-pill">{t("wallets.transak.convenient")}</span>
        </div>

        <div className="card-text">
          <h5 className="card-title">{t("wallets.transak.buy_usdt_title")}</h5>

          <span>
            <small className="font-0_8">
              {t("wallets.transak.use_crypto")}
            </small>
          </span>

          <div className="py-4 text-center">
            <img
              src={require("../../../assets/images/visa.png")}
              style={{ width: "40px" }}
              alt="Visa"
            />
            <img
              src={require("../../../assets/images/mastercard.png")}
              style={{ width: "40px", marginLeft: "10px" }}
              alt="Mastercard"
            />
            <img
              src={require("../../../assets/images/apple_pay.svg")}
              style={{ width: "45px", marginLeft: "10px" }}
              alt="Apple Pay"
            />
            <img
              src={require("../../../assets/images/google_pay.svg")}
              style={{ width: "45px", marginLeft: "10px" }}
              alt="Google Pay"
            />
            <img
              src={require("../../../assets/images/payment_networks/cashapp.png")}
              style={{ width: "80px", marginLeft: "10px" }}
              alt="Cash App"
            />
            <img
              src={require("../../../assets/images/payment_networks/venmo.svg")}
              style={{ width: "55px", marginLeft: "10px" }}
              alt="Venmo"
            />

            <span style={{ width: "10px", paddingLeft: "6px" }}>
              <strong>
                <i className="fa fa-university" /> {t("wallets.transak.bank_transfer")}
              </strong>
            </span>
          </div>

          <span className="card-text-time">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-clock h-4 w-4"
            >
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>{" "}
            {t("wallets.transak.convenient_time")}
          </span>

          <div className="mt-1">
            <small className="card-text-info">
              {t("wallets.transak.buy_info")}
            </small>
          </div>
        </div>
      </div>

      <div className="p-2 pb-3 card-fund-bottom">
        <button
          className="btn btn-purple text-center w-100 rounded-lg"
          style={{ color: "white" }}
          disabled={submitting}
          onClick={(e) => onSubmit(e)}
        >
          {submitting ? (
            <>
              <i className="fa fa-circle-o-notch fa-spin"></i>
              <span style={{ paddingLeft: "5px" }}>{t("wallets.transak.please_wait")}</span>
            </>
          ) : (
            <span>
              <i className="fa fa-plus-square-o" /> {t("wallets.transak.fund_via_buying")}{" "}
              <i className="fa fa-long-arrow-right ml-2" />
            </span>
          )}
        </button>

        <a
          className="text-muted d-flex justify-content-center align-items-center mt-2"
          href="https://www.bananacrystal.com/docs/how-to-fund-your-account-with-a-card-apple-pay-google-pay-or-bank-transfer/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <small>
            <i className="fa fa-info-circle mr-1" />
            {t("wallets.transak.how_to_buy")}
          </small>
        </a>
      </div>
    </div>
  );
};

export default CreateWidget;
